export default async function ({ route, redirect }) {
  if (!route.query.uid || !route.query.token) redirect("/")
}
